module.exports = __webpack_public_path__ + "static/media/video_back_altern.67746f08.mp4";